import { SVGAttributes } from "react"

export function CheckIcon(props: SVGAttributes<SVGSVGElement>) {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M28.7075 9.7075L12.7075 25.7075C12.6146 25.8005 12.5043 25.8742 12.3829 25.9246C12.2615 25.9749 12.1314 26.0008 12 26.0008C11.8686 26.0008 11.7385 25.9749 11.6171 25.9246C11.4957 25.8742 11.3854 25.8005 11.2925 25.7075L4.2925 18.7075C4.10486 18.5199 3.99944 18.2654 3.99944 18C3.99944 17.7346 4.10486 17.4801 4.2925 17.2925C4.48014 17.1049 4.73464 16.9994 5 16.9994C5.26536 16.9994 5.51986 17.1049 5.7075 17.2925L12 23.5863L27.2925 8.2925C27.4801 8.10486 27.7346 7.99944 28 7.99944C28.2654 7.99944 28.5199 8.10486 28.7075 8.2925C28.8951 8.48014 29.0006 8.73464 29.0006 9C29.0006 9.26536 28.8951 9.51986 28.7075 9.7075Z"
                fill="#C3C7D3"
            />
        </svg>
    )
}
